/* global $:true module:true */
// import 'babel-polyfill';
import debug from "debug";


const MODULE_NAME = 'app.core';
const log = debug(MODULE_NAME);


log('Running...');

import modules from './modules';
// import services from './services';
import vendor from './vendor';

vendor.vue.onAfterInit((Vue) => {
    log("Vue ready", Vue);
});

$(document).ready(() => {
    log('Running document ready tasks...');

    // Run Foundation
    log('vendor', vendor);
    vendor.foundation.exec();

    // Run Modules
    log('modules', modules);
    modules.exec();

    // start Vue ;
    vendor.vue.exec();

});


// WEBPACK FOOTER //
// ./client/src/core/index.js